import _ from 'lodash';
import { createSelector } from 'reselect';

import { CRM_PROPERTY_KEYS } from 'constants/crmFeatures';

// Concrete-module import (not the store/auth/selectors barrel): this file loads
// transitively under navigation.selectors in many test suites whose partial barrel
// mocks would leave selectMasterCompanyId undefined at module-init time.
import { selectMasterCompanyId } from 'store/auth/selectors/master.selectors';

import { getCompany } from './company.selectors';
import { getCompanyPropertiesState } from './companyProperties.selectors';

export const selectMasterCompanyPropertiesNew = createSelector(
  [getCompanyPropertiesState, selectMasterCompanyId],
  (companyProperties, masterCompanyId) => companyProperties[masterCompanyId],
);

const getCompanyPropertiesSettledState = createSelector(
  getCompany,
  ({ companyPropertiesSettled }) => companyPropertiesSettled,
);

// Settled (success OR failure) — see companyPropertiesSettled.reducer.js for why this is
// separate from the data slice. A session with no resolved master company id (unresolved
// broker auth context, token-injected iframe) has nothing to wait for, so it counts as
// settled and the gates fall through to the enabled defaults.
export const selectAreMasterCompanyPropertiesSettled = createSelector(
  [getCompanyPropertiesSettledState, selectMasterCompanyId],
  (settledCompanyIds, masterCompanyId) =>
    !masterCompanyId || settledCompanyIds[masterCompanyId] === true,
);

// CRM stays enabled unless the company explicitly opts out with EnableCrm=false,
// so companies without the property (and sessions where the fetch has not settled
// yet) keep today's behavior.
export const selectIsCrmEnabledForCompany = createSelector(
  selectMasterCompanyPropertiesNew,
  properties => {
    const enableCrmProperty = _.find(properties, {
      propertyName: CRM_PROPERTY_KEYS.ENABLE_CRM,
    });

    return _.toLower(enableCrmProperty?.propertyValue) !== 'false';
  },
);
